export class ForgotPasswordRequest {
  public UserName: string;
  public RequestMode: string;
  public RequestType: number;
  public MobileNo: string;
  public EmailID: string;
  public OTPActivationNo: string;
}
